import React from 'react';
const ListenSvg = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      className={className}
    >
      <rect
        x="0.492188"
        width="27.9964"
        height="28"
        rx="13.9982"
        fill={color}
      />
      <path
        d="M20.7155 7H19.5492C19.3339 7 19.1602 7.17444 19.1602 7.389C19.1602 7.60355 19.3339 7.77799 19.5492 7.77799H20.7155V8.94433C20.7155 9.15955 20.8899 9.33332 21.1045 9.33332C21.319 9.33332 21.4935 9.15955 21.4935 8.94433V7.77799C21.4935 7.57146 21.4113 7.37361 21.2656 7.22791C21.1199 7.08222 20.922 7 20.7155 7Z"
        fill="white"
      />
      <path
        d="M7.88119 9.33342C7.98412 9.33342 8.08304 9.29265 8.1559 9.2198C8.22942 9.14694 8.2702 9.04802 8.2702 8.94442V7.77808H9.43653C9.65175 7.77808 9.82553 7.60364 9.82553 7.38909C9.82553 7.17454 9.65175 7.00009 9.43653 7.00009H8.2702C7.84043 7.00009 7.49219 7.34833 7.49219 7.7781V8.94444C7.49219 9.04804 7.53363 9.14696 7.60648 9.21982C7.67934 9.29267 7.77825 9.33342 7.88119 9.33342Z"
        fill="white"
      />
      <path
        d="M21.1045 18.6666C20.8899 18.6666 20.7155 18.8404 20.7155 19.0556V20.222H19.5492C19.3339 20.222 19.1602 20.3964 19.1602 20.611C19.1602 20.8255 19.3339 21 19.5492 21H20.7155C20.922 21 21.1199 20.9177 21.2656 20.772C21.4113 20.6263 21.4935 20.4285 21.4935 20.222V19.0556C21.4935 18.952 21.452 18.8531 21.3792 18.7803C21.3063 18.7074 21.2074 18.6666 21.1045 18.6666Z"
        fill="white"
      />
      <path
        d="M9.43651 20.222H8.27018V19.0557C8.27018 18.8404 8.09573 18.6667 7.88118 18.6667C7.66663 18.6667 7.49219 18.8404 7.49219 19.0557V20.222C7.49219 20.4285 7.5744 20.6264 7.7201 20.7721C7.86581 20.9178 8.06365 21 8.27018 21H9.43651C9.65173 21 9.82551 20.8255 9.82551 20.611C9.82551 20.3964 9.65173 20.222 9.43651 20.222Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4883 12C11.4883 10.3431 12.8314 9 14.4883 9C16.1451 9 17.4883 10.3431 17.4883 12C17.4883 13.6568 16.1451 15 14.4883 15C12.8314 15 11.4883 13.6568 11.4883 12Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2035 16.4513C12.016 16.1107 13.0997 16.0001 14.488 16.0001C15.8735 16.0001 16.9556 16.1103 17.7673 16.4491C18.6386 16.8128 19.1734 17.4307 19.4585 18.3294C19.5644 18.6634 19.3139 19.0001 18.9676 19.0001H10.0053C9.66045 19.0001 9.41143 18.6649 9.51649 18.3328C9.80072 17.4341 10.3336 16.816 11.2035 16.4513Z"
        fill="white"
      />
    </svg>
  );
};

export default ListenSvg;
